import View from './View';

class CreateView extends View {
    constructor(name) {
        super(name);
        this._type = 'CreateView';
    }
}

export default CreateView;



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./~/admin-config/lib/View/CreateView.js
 **/